module.exports = __webpack_public_path__ + "faq/img/assignment.1e80b0a4.png";